import { inject, LogManager } from 'aurelia-framework';
import { DialogController } from 'aurelia-dialog';
import { UserServices } from 'UserServices.js';
import { Router } from 'aurelia-router';

let logger = LogManager.getLogger('logindialog.js');

@inject(DialogController, UserServices, Router)
export class LoginDialog {

	constructor(controller, userServices, router) {
		this.controller = controller;
		this.userServices = userServices;
		this.router = router;
	}

	// Interface functions
	scrollEmail() {
		$('.externalLogin').slideUp();
		$('.emailLogin').slideDown();
	}

	scrollDownEmail() {
		$('.emailLogin').slideUp();
		$('.externalLogin').slideDown();
	}

	// Functionality
	signin() {
		this.userServices.login({
			email: this.email,
			password: this.password
		}, {}, 0).then((response) => {	// Do not redirect
			this.controller.ok();
		}).catch((error) => {
			this.error = error;
			logger.error(error);
		});
	}

	authenticate(provider) {
		this.userServices.authenticate(provider, '#/' + this.router.currentInstruction.fragment)
			.then((response) => {
				this.controller.ok();
			})
			.catch((error) => {
				logger.error(error);
			});
	}

	register() {
		this.controller.cancel();
		this.router.navigateToRoute('register');
	}
}
